import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';

import WaterTester from '../../../../models/waterTester';

import ToolTip, {tooltipPositions} from '../../../components/ToolTip';
import EditableList from '../../../components/forms/editableList';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Row from '../../../components/Row';
import Col from '../../../components/Col';

class StoreTesters extends PureComponent {
  render() {
    const {waterTesters, edit, deleteTester, editTester, activeStoreID, store} = this.props;

    return <div>
      <h2 className='with-keyline'>
        <FormattedMessage id="general.water.testers" />&nbsp;
        <ToolTip iconOnly={true} title={this.props.intl.formatMessage({id: 'preferences.employee.first.name'})} position={tooltipPositions.topRight} />
      </h2>
      <Row>
        <Col sm={12} className='water-testers'>
          {waterTesters.length > 0 || edit ?
            <EditableList dataKey='waterTesters'
                            items={waterTesters}
                            onChange={editTester}
                            onDelete={deleteTester}
                            editMode={edit}
                            type={WaterTester}
                            filter={t => !t.deleted && t.branchID === store.id}
                            objectKey='name'
                            defaultNewObject={{branchID: activeStoreID}} /> :
            <div><FormattedMessage id="preferences.error.water.tester" /></div>}
        </Col>
      </Row>
    </div>;
  }
}
StoreTesters.propTypes = {
  activeStoreID: PropTypes.number,
  deleteTester: PropTypes.func,
  edit: PropTypes.bool,
  editTester: PropTypes.func,
  store: PropTypes.object.isRequired,
  waterTesters: PropTypes.array.isRequired,
};

export default injectIntl(StoreTesters);
